import { render } from "./blockPiramide.vue?vue&type=template&id=76a52670&scoped=true"
import script from "./blockPiramide.vue?vue&type=script&lang=js"
export * from "./blockPiramide.vue?vue&type=script&lang=js"

import "./blockPiramide.vue?vue&type=style&index=0&id=76a52670&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a52670"]])

export default __exports__